module.exports = __webpack_public_path__ + "img/home-device-icon.9f69863a.svg";